import { render, staticRenderFns } from "./LegalProfilePage.vue?vue&type=template&id=fa131232&"
import script from "./LegalProfilePage.vue?vue&type=script&lang=js&"
export * from "./LegalProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports